const CountryIndex = () => import("Pages/Admin/Country/Index.vue");
const CountryForm = () => import("Pages/Admin/Country/Form.vue");

const CurrencyIndex = () => import("Pages/Admin/Currency/Index.vue");
const CurrencyForm = () => import("Pages/Admin/Currency/Form.vue");

const ProfileIndex = () => import("Pages/Admin/Profile/Index.vue");

const PermissionIndex = () => import("Pages/Admin/Permission/Index.vue");
const PermissionForm = () => import("Pages/Admin/Permission/Form.vue");

const RoleIndex = () => import("Pages/Admin/Role/Index.vue");
const RoleForm = () => import("Pages/Admin/Role/Form.vue");

const TranslationSectionIndex = () => import("Pages/Admin/Translations/SectionsIndex.vue");
const TranslationSectionForm = () => import("Pages/Admin/Translations/SectionsForm.vue");

const UserIndex = () => import("Pages/Admin/User/Index.vue");
const UserCreate = () => import("Pages/Admin/User/Create.vue");
const UserEdit = () => import("Pages/Admin/User/Edit.vue");

// Finance
const BillerIndex = () => import("Pages/Admin/Biller/Index.vue");
const BillerForm = () => import("Pages/Admin/Biller/Form.vue");
const PackageIndex = () => import("Pages/Admin/Package/Index.vue");
const PackageForm = () => import("Pages/Admin/Package/Form.vue");
const PromotionIndex = () => import("Pages/Admin/Promotion/Index.vue");
const PromotionForm = () => import("Pages/Admin/Promotion/Form.vue");
const TransactionIndex = () => import("Pages/Admin/Transaction/Index.vue");
const PayoutIndex = () => import("Pages/Admin/Payout/Index.vue");

export default [
  {
    path: "/admin/countries",
    component: CountryIndex,
    name: "countries",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/countries/create",
    component: CountryForm,
    name: "create-countries",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/countries/:id",
    component: CountryForm,
    name: "edit-countries",
    props: true,
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/currencies",
    component: CurrencyIndex,
    name: "currencies",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/currencies/create",
    component: CurrencyForm,
    name: "create-currencies",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/currencies/:id",
    component: CurrencyForm,
    name: "edit-currencies",
    props: true,
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },

  {
    path: "/admin/profiles",
    component: ProfileIndex,
    name: "profiles",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/permissions",
    component: PermissionIndex,
    name: "permissions",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/permissions/create",
    component: PermissionForm,
    name: "create-permission",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/permissions/:id",
    component: PermissionForm,
    name: "edit-permission",
    props: true,
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/roles",
    component: RoleIndex,
    name: "roles",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/roles/create",
    component: RoleForm,
    name: "create-role",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/roles/:id",
    component: RoleForm,
    name: "edit-role",
    props: true,
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },

  {
    path: "/admin/translation_sections",
    component: TranslationSectionIndex,
    name: "translation-sections",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/translation_sections/create",
    component: TranslationSectionForm,
    name: "create-translation-section",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/translation_sections/:id",
    component: TranslationSectionForm,
    name: "edit-translation-section",
    props: true,
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/users",
    component: UserIndex,
    name: "users",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/users/create",
    component: UserCreate,
    name: "create-user",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/users/:id",
    component: UserEdit,
    name: "edit-user",
    props: true,
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  /* Finance */
  {
    path: "/admin/billers",
    component: BillerIndex,
    name: "billers",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/billers/create",
    component: BillerForm,
    name: "create-biller",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/billers/:id",
    component: BillerForm,
    name: "edit-biller",
    props: true,
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/packages",
    component: PackageIndex,
    name: "packages",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/packages/create",
    component: PackageForm,
    name: "create-package",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/packages/:id",
    component: PackageForm,
    name: "edit-package",
    props: true,
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/promotions",
    component: PromotionIndex,
    name: "promotions",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/promotions/create",
    component: PromotionForm,
    name: "create-promotion",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/promotions/:id",
    component: PromotionForm,
    name: "edit-promotion",
    props: true,
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/transactions",
    component: TransactionIndex,
    name: "transactions",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  {
    path: "/admin/payouts",
    component: PayoutIndex,
    name: "payouts",
    meta: {
      requiresAuth: true,
      permission: "guest",
      fail: "/404.html"
    }
  },
  /* End Authenticated Routes */
];


// WEBPACK FOOTER //
// ./resources/js/routes/admin.js